import request from '../../request';
import { constructUrlObject } from '../../../utils/shared/urlUtils';
import { PARAM } from '../../../constants/shared/ApiConstants';

const { STUDENT_IDS, MOST_OFFICIAL } = PARAM;

class SharedTranslatorClient {
    static getResults = (url, studentIds, additionalURLParams = {}) => {
        const urlWithQueryParams = constructUrlObject(url, {
            [STUDENT_IDS]: studentIds.join(),
            [MOST_OFFICIAL]: true,
            ...additionalURLParams,
        });
        return request.get(urlWithQueryParams);
    };
}

export default SharedTranslatorClient;
